module.exports = "h1 {\n  font-size: 5em; }\n"